<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

const props = withDefaults(defineProps<{
  text: string
  href?: string
  to?: RouteLocationRaw
  variant?: 'default' | 'submenu'
  menuCategory1?: string
  menuCategory2?: string
}>(), {
  variant: 'default',
});

const emit = defineEmits<{
  click: []
}>();

const { linkComponent, linkBindings } = useLinksBuilder(props);

function onClick() {
  if (props.menuCategory1) {
    trackEvent({
      event: 'menu_interaction',
      event_name: 'header_click',
      menu_category1: props.menuCategory1,
      menu_category2: props.menuCategory2,
    });
  }
  emit('click');
}
</script>

<template>
  <component
    :is="linkComponent"
    v-bind="linkBindings"
    class="font-semibold w-full flex justify-between gap-s
      group-[.is-prestige]:font-normal group-[.is-prestige]:uppercase group-[.is-prestige]:tracking-wider group-[.is-prestige]:items-end"
    :class="{
      'text-lg lg:w-80 group-[.is-prestige]:text-base': variant === 'submenu',
      'lg:w-auto': variant === 'default',
    }"
    @click="onClick"
  >
    {{ text }}
    <IadBtn
      :class="{
        'lg:hidden': variant === 'default',
      }"
      variant="outlined"
      size="small"
      icon
      tag="div"
    >
      <Icon name="iad-icon:arrow-right" />
    </IadBtn>
  </component>
</template>
